var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 9C7.3125 8.06802 8.06802 7.3125 9 7.3125C9.93198 7.3125 10.6875 8.06802 10.6875 9C10.6875 9.93198 9.93198 10.6875 9 10.6875C8.06802 10.6875 7.3125 9.93198 7.3125 9Z",
    fill: "#2D264B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7638 4.19679C5.94244 3.23174 7.39429 2.4375 9 2.4375C10.6057 2.4375 12.0576 3.23174 13.2362 4.19679C14.4213 5.1671 15.3903 6.35899 16.0414 7.26601L16.0951 7.3407C16.4871 7.88538 16.8098 8.33374 16.8098 9C16.8098 9.66626 16.4871 10.1146 16.0951 10.6593L16.0414 10.734C15.3903 11.641 14.4213 12.8329 13.2362 13.8032C12.0576 14.7683 10.6057 15.5625 9 15.5625C7.39429 15.5625 5.94244 14.7683 4.7638 13.8032C3.57873 12.8329 2.60971 11.641 1.95856 10.734L1.90486 10.6593C1.51286 10.1146 1.19019 9.66626 1.19019 9C1.19019 8.33374 1.51286 7.88538 1.90486 7.34069L1.95856 7.26601C2.60971 6.35899 3.57873 5.1671 4.7638 4.19679ZM9 6.1875C7.4467 6.1875 6.1875 7.4467 6.1875 9C6.1875 10.5533 7.4467 11.8125 9 11.8125C10.5533 11.8125 11.8125 10.5533 11.8125 9C11.8125 7.4467 10.5533 6.1875 9 6.1875Z",
    fill: "#2D264B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.8a871cc875a278077d311585a5244287.svg";
export { ForwardRef as ReactComponent };